var _g, _g2, _g3, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_821_34936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z",
    fill: "url(#paint0_linear_821_34936)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_821_34936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.751 2.45703C19.751 2.25563 19.8088 2.127 19.6992 2.10547C19.8034 2.11211 19.9549 2.14986 20.0508 2.1875C20.174 2.23589 20.0219 2.34273 20.1183 2.43694C20.1212 2.43968 20.124 2.44244 20.1267 2.44524L26.38 8.6985C26.399 8.71757 26.4173 8.73732 26.4346 8.75771C26.52 8.85806 26.5842 8.97371 26.6243 9.09766C26.6562 9.19624 26.6729 9.30006 26.6729 9.40561V9.46875C26.6729 9.23655 26.5049 9.09766 26.38 9.09766H20.951C20.2883 9.09766 19.751 8.56039 19.751 7.89766V2.45703Z",
    fill: "#D2C5DF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_821_34936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z",
    fill: "url(#paint1_linear_821_34936)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z",
    fill: "url(#paint2_linear_821_34936)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.03906,
    y: 11.9961,
    width: 13.9141,
    height: 0.992188,
    rx: 0.496094,
    fill: "url(#paint3_linear_821_34936)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03906,
    y: 14.9961,
    width: 13.9141,
    height: 0.992188,
    rx: 0.496094,
    fill: "url(#paint4_linear_821_34936)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03906,
    y: 17.9961,
    width: 13.9141,
    height: 0.992188,
    rx: 0.496094,
    fill: "url(#paint5_linear_821_34936)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03906,
    y: 20.9961,
    width: 8.98438,
    height: 0.992188,
    rx: 0.496094,
    fill: "url(#paint6_linear_821_34936)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0732 13.4985C25.7137 12.9731 26.6588 13.0663 27.1843 13.7068L29.1349 16.0846C29.6603 16.7251 29.567 17.6702 28.9265 18.1957L14.7887 29.7936L10.9354 25.0964L25.0732 13.4985Z",
    fill: "url(#paint7_radial_821_34936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0732 13.4985C25.7137 12.9731 26.6588 13.0663 27.1843 13.7068L29.1349 16.0846C29.6603 16.7251 29.567 17.6702 28.9265 18.1957L14.7887 29.7936L10.9354 25.0964L25.0732 13.4985Z",
    fill: "url(#paint8_linear_821_34936)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0732 13.4985C25.7137 12.9731 26.6588 13.0663 27.1843 13.7068L29.1349 16.0846C29.6603 16.7251 29.567 17.6702 28.9265 18.1957L14.7887 29.7936L10.9354 25.0964L25.0732 13.4985Z",
    fill: "url(#paint9_linear_821_34936)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0732 13.4985C25.7137 12.9731 26.6588 13.0663 27.1843 13.7068L29.1349 16.0846C29.6603 16.7251 29.567 17.6702 28.9265 18.1957L14.7887 29.7936L10.9354 25.0964L25.0732 13.4985Z",
    fill: "url(#paint10_radial_821_34936)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84239 29.7946C9.82645 29.8763 9.88888 29.9523 9.9721 29.9525L14.3257 29.9635C14.451 29.9638 14.5738 29.9286 14.6798 29.862L14.7886 29.7937L10.9353 25.0965L10.8611 25.1702C10.767 25.2637 10.7032 25.3832 10.6778 25.5133L9.84239 29.7946Z",
    fill: "url(#paint11_linear_821_34936)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84239 29.7946C9.82645 29.8763 9.88888 29.9523 9.9721 29.9525L14.3257 29.9635C14.451 29.9638 14.5738 29.9286 14.6798 29.862L14.7886 29.7937L10.9353 25.0965L10.8611 25.1702C10.767 25.2637 10.7032 25.3832 10.6778 25.5133L9.84239 29.7946Z",
    fill: "url(#paint12_linear_821_34936)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84239 29.7946C9.82645 29.8763 9.88888 29.9523 9.9721 29.9525L14.3257 29.9635C14.451 29.9638 14.5738 29.9286 14.6798 29.862L14.7886 29.7937L10.9353 25.0965L10.8611 25.1702C10.767 25.2637 10.7032 25.3832 10.6778 25.5133L9.84239 29.7946Z",
    fill: "url(#paint13_linear_821_34936)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z",
    fill: "url(#paint14_linear_821_34936)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z",
    fill: "url(#paint15_linear_821_34936)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z",
    fill: "url(#paint16_radial_821_34936)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8496 16.9634L23.1601 15.0679L27.0135 19.7651L24.7029 21.6605L20.8496 16.9634Z",
    fill: "url(#paint17_linear_821_34936)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8496 16.9634L23.1601 15.0679L27.0135 19.7651L24.7029 21.6605L20.8496 16.9634Z",
    fill: "url(#paint18_linear_821_34936)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97241 29.9523C9.88917 29.9521 9.82674 29.8761 9.84268 29.7944L10.1357 28.2925L11.5005 29.9561L9.97241 29.9523Z",
    fill: "url(#paint19_linear_821_34936)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_821_34936",
    x: 4.93906,
    y: 1.74297,
    width: 22.3219,
    height: 28.3141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.768627 0 0 0 0 0.85098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34936"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.709804 0 0 0 0 0.690196 0 0 0 0 0.733333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_821_34936",
    result: "effect2_innerShadow_821_34936"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72549 0 0 0 0 0.65098 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_821_34936",
    result: "effect3_innerShadow_821_34936"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.941176 0 0 0 0 0.964706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_821_34936",
    result: "effect4_innerShadow_821_34936"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_821_34936",
    x: 19.1992,
    y: 1.60547,
    width: 7.97363,
    height: 8.36328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_821_34936"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_821_34936",
    x: 19.7715,
    y: 1.94492,
    width: 7.28945,
    height: 7.41445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.611765 0 0 0 0 0.654902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_821_34936"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.752941 0 0 0 0 0.67451 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_821_34936",
    result: "effect2_innerShadow_821_34936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_821_34936",
    x1: 16,
    y1: 2.04297,
    x2: 16,
    y2: 30.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC1D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_821_34936",
    x1: 20.5391,
    y1: 8.70696,
    x2: 23.1797,
    y2: 6.06633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB4C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_821_34936",
    x1: 23.7735,
    y1: 5.5507,
    x2: 22.5157,
    y2: 6.82043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119171,
    stopColor: "#DBDADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577307,
    stopColor: "#CBC7D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_821_34936",
    x1: 9.03906,
    y1: 12.4922,
    x2: 22.9531,
    y2: 12.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A95A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_821_34936",
    x1: 9.03906,
    y1: 15.4922,
    x2: 22.9531,
    y2: 15.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A95A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_821_34936",
    x1: 9.03906,
    y1: 18.4922,
    x2: 22.9531,
    y2: 18.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A95A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_821_34936",
    x1: 9.03906,
    y1: 21.4922,
    x2: 18.0234,
    y2: 21.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A95A1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_821_34936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8344 27.5718) rotate(-40.0074) scale(13.0302 8.0826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3633D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_821_34936",
    x1: 16.1544,
    y1: 20.4931,
    x2: 17.087,
    y2: 21.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE9B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9B6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_821_34936",
    x1: 22.8413,
    y1: 23.5663,
    x2: 21.7068,
    y2: 22.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66A62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E66A62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_821_34936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6818 27.4319) rotate(-39.2242) scale(12.0339 2.691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF994D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF994D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_821_34936",
    x1: 11.3036,
    y1: 27.4832,
    x2: 12.7659,
    y2: 30.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8A587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7A98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_821_34936",
    x1: 13.3311,
    y1: 27.8088,
    x2: 12.9515,
    y2: 28.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.207411,
    stopColor: "#FFC09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_821_34936",
    x1: 9.74786,
    y1: 27.2256,
    x2: 11.1367,
    y2: 27.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBCA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBCA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_821_34936",
    x1: 28.6275,
    y1: 15.1083,
    x2: 25.6434,
    y2: 17.5183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_821_34936",
    x1: 23.8306,
    y1: 14.3852,
    x2: 25.7782,
    y2: 16.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1553E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1553E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_821_34936",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0102 15.6715) rotate(140.636) scale(0.907664 2.06194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177419,
    stopColor: "#FF786D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF786D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_821_34936",
    x1: 22.0408,
    y1: 16.0809,
    x2: 24.5164,
    y2: 18.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_821_34936",
    x1: 25.8708,
    y1: 21.119,
    x2: 24.4926,
    y2: 19.4851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9B9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B9E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_821_34936",
    x1: 10.0533,
    y1: 28.9823,
    x2: 10.6569,
    y2: 30.0204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#461E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#450F51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriters);
export default __webpack_public_path__ + "static/media/Writers.2fe3094e6fd2c1be9608fe09497378fb.svg";
export { ForwardRef as ReactComponent };